
import {functions} from "@/scripts/firebase"
import {getDoc} from 'firebase/firestore'
import {httpsCallable} from 'firebase/functions'
//import {getDownloadURL,uploadBytes,ref} from 'firebase/storage'
import { ModalConfirmProps, NoticeProps} from "@/scripts/datatypes"
import { UserPublicProfile, UserPrivateProfile, Roles, GetUserRolesAccessLevelsRes, UserRelationship, ResetAuthUidArg, ResetAuthUidRes} from "../../common-datatypes";
import { Component,Watch ,Mixins} from "vue-property-decorator";
import ModalConfirm from "@/components/ModalConfirm.vue"
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
import {toHiragana,toZenKana} from 'jaconv'
import { ValidationFlags } from "vee-validate/dist/types/types";
import TemplateMembers from '@/components/TemplateMembers.vue'

/**
 * authデータ処理から
 * アカウント停止
 * 自分の権限より下のもののアカウントのみ停止にできる
 * 
 * 権限変更
 * 自分の権限以下のアカウントのみ権限変更(自分の権限以下)できる
 * 
 */


@Component({
  components: {
    ModalConfirm,
    TemplateMembers
  }
})

export default class EditUser extends Mixins(Common) {
  initialized = false
  isLoading = false
  notice: NoticeProps = {}
  disabledUpdateProfile = true
  userPublicProfile = {} as UserPublicProfile
  userPrivateProfile = {} as UserPrivateProfile
  userRolesAccessLevels =  {} as GetUserRolesAccessLevelsRes
  userRelationship = {} as UserRelationship
  telInputShowFlags = true
  phoneObject = {number: '',valid: false,formatted: ''}
  showModalDeleteUser = false

  observer = {} as  InstanceType<typeof ValidationObserver>

  modalDeleteUser = {title: 'editUser.deleteUser',message: '', 'confirmText': 'editUser.deleteUser',isLoading: false}

  modalResetUid: ModalConfirmProps = {
    isShow:false,
    title: 'editUser.resetUid',
    message: '', confirmText: 'editUser.resetUid',
    isLoading: false
  }

  unlinkLineAccountConfirmProps: ModalConfirmProps = {
    isShow: false,
    isLoading: false,
    title: 'formFields.lineAccount.unlink',
    message: 'editUser.unLinkLineAccountDescription',
  }

  unlinkLineAccountConfirm($event: boolean){
    if($event){
      this.unlinkLineAccount()
    }else{
      this.unlinkLineAccountConfirmProps.isShow = false
    }
  }

  async unlinkLineAccount(){
    try{
      if(this.userPrivateProfile.lineUserId){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        this.unlinkLineAccountConfirmProps.isLoading = true
        const updatePrivateProfile = {
          lineUserId: '',
        }
        await this.$updateDoc(this.$getUserPrivateProfileDocRef(),updatePrivateProfile)

        this.userPrivateProfile.lineUserId = ''
      }
    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.unlinkLineAccountConfirmProps.isLoading = false
      this.unlinkLineAccountConfirmProps.isShow = false
    }
  }

  get displayName(){
    return this.$t('text.name', {lastName: this.userPublicProfile.lastName || '', firstName: this.userPublicProfile.firstName || ''})
  }

  get existUser(){
    if(this.userRolesAccessLevels && Object.keys(this.userPublicProfile).length > 0 && Object.keys(this.userPrivateProfile).length > 0 && Object.keys(this.userRelationship).length > 0){
      return true
    }else{
      return false
    }
  }

  @Watch('initialized',{immediate: true})
  changeInitializedStatus(newVal: boolean){
    if(! newVal){
      this.notice = {
        message: this.$t('editUser.loadingUserData') as string,
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
    }else if(! this.existUser){
      this.notice = {
        message: this.$t('editUser.noUserFound') as string,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }else{
      this.notice = {
        isShow: false,
      }
      this.modalDeleteUser.message = this.$t('editUser.deleleUserDescription',{name: this.displayName}) as string
      this.modalResetUid.message = this.$t('editUser.resetUidDescription',{name: this.displayName}) as string
    }
  }

  get theUserId(){
    return this.$route.params.userId || ''
  }

  public inputPhoneNumber(number: string, phoneObject: {number: string; valid: boolean; formatted: string}){
    this.phoneObject = phoneObject    
  }

   public validatePhoneNumber(phoneObject: {number: string; valid: boolean; formatted: string}){
    console.log(phoneObject)
  }

 countryChanged(countryObject: {dialCode: string}){
    console.log(countryObject)
    if(this.changeCountryCount === 0){
      this.$nextTick(() => {
        this.observer.reset()
      })
    }
    this.changeCountryCount ++
  }

  changeCountryCount = 0

  mounted(){
    console.log('mounted')
  }

  beforeUpdate(){
    console.log('beforeUpdate')
  }

  updated(){
    console.log('updated')
    if( ! this.observer.flags && this.$refs.editUserValidationObserver){
      this.observer = this.$refs.editUserValidationObserver as InstanceType<typeof ValidationObserver>
    }
  }

  @Watch('observer.flags')
  changeObservserFlags(flags: ValidationFlags){
    this.disabledUpdateProfile = ! flags.changed
  }

  async created() {
    console.trace('created')
 
    try{
      this.$store.commit('setLoading',true)
      this.isLoading = true

      const [userPublicProfileDoc,userPrivateProfileDoc,userRelationshipDoc,userRolesAccessLevels] = await Promise.all([
        getDoc(this.$getUserPublicProfileDocRef(this.theUserId)),
        getDoc(this.$getUserPrivateProfileDocRef(this.theUserId)),
        getDoc(this.$getUserRelationshipDocRef(this.theUserId)),
        this.$getUserRolesAccessLevels(this.$store.getters.schoolId)
      ])

      this.userPublicProfile = ((userPublicProfileDoc.exists() && userPublicProfileDoc.get('deleted') !== true) ? userPublicProfileDoc.data() : {}) as UserPublicProfile

      this.userPrivateProfile = (userPrivateProfileDoc.exists() ? userPrivateProfileDoc.data() : {}) as UserPrivateProfile

      if(! this.userPrivateProfile.timeZone){
        this.userPrivateProfile.timeZone = this.$defaultTimeZone
      }

      this.userRelationship = (userRelationshipDoc.exists() ? userRelationshipDoc.data() : {}) as UserRelationship

      this.userRolesAccessLevels = userRolesAccessLevels.data
     
      this.$watch('userPublicProfile',(newVal: UserPublicProfile) => {

        if(newVal.lastNameYomigana){
          newVal.lastNameYomigana = toHiragana(toZenKana(newVal.lastNameYomigana))
          newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
        }

        if(newVal.firstNameYomigana){
          newVal.firstNameYomigana = toHiragana(toZenKana(newVal.firstNameYomigana))
          newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
        }

      },{deep: true})
    
    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoading = false
      this.initialized = true
    }
  }

  get languages(): string[]{
    if(this.$i18n.availableLocales){
      return this.$i18n.availableLocales
    }
    return [];
  }

  get roles(): string[]{
    const roles = Object.keys(this.userRolesAccessLevels || {})
    return roles
    /*
    return roles.sort((a,b) => {
      const uLa = this.userRolesAccessLevels[roles[a as any]]
      const uLb = this.userRolesAccessLevels[roles[b as any]]
      return uLa.accessLevel - uLb.accessLevel
    })
    */
  }

  get hasAuth(){
    if(this.roles.length === 0 || ! Array.isArray(this.userPublicProfile.roles)){
      return false
    }

    return this.userPublicProfile.roles.every((role) => {
        return this.roles.includes(role)
      }
    )
  }

  async updateProfile(){
    try{
      this.notice = {
				isShow: false,
      }

			if(this.phoneObject.valid === false || ! await this.observer.validate()){
        if(this.phoneObject.valid === false){
          this.observer.setErrors({
            phoneNumber: this.$t('authentication.errorCode.auth/invalid-phone-number') as string
          })
        }
        return
      }

      const updatePublicProfile = {...this.userPublicProfile}
      console.log(updatePublicProfile)
      const updatePrivateProfile = {
        ...this.userPrivateProfile,
        phoneNumber: this.phoneObject.number || ''
      }
      let field: string
      
      for(field in this.userPublicProfile){
        if(field === 'roles'){
          console.log(this.observer.fields[field])
        }
        if(this.observer.fields[field] && (this.observer.fields[field].dirty === true || this.observer.fields[field].changed === true)){
          continue
        }
        
        delete(updatePublicProfile[field as keyof UserPublicProfile])
      }

      for(field in this.userPrivateProfile){
        if(this.observer.fields[field] && (this.observer.fields[field].dirty === true || this.observer.fields[field].changed === true)){
          continue
        }
        delete(updatePrivateProfile[field as keyof UserPrivateProfile])
      }
        
      if(Object.keys(updatePublicProfile).length > 0 || Object.keys(updatePrivateProfile).length > 0){

        this.$store.commit("setLoading",true);
        this.isLoading = true

        if(Object.keys(updatePublicProfile).length > 0){
          console.log('public')
          console.log(updatePublicProfile)

          const userPublicProfileRes = await this.$updateDoc(this.$getUserPublicProfileDocRef(this.theUserId),updatePublicProfile)

          if(updatePublicProfile.roles && this.$store.getters.userId === this.theUserId && userPublicProfileRes){
            this.userPublicProfile.roles = userPublicProfileRes.get('roles')
          }
        }

        if(Object.keys(updatePrivateProfile).length > 0){
          console.log('private')
          console.log(updatePrivateProfile)
          await this.$updateDoc(this.$getUserPrivateProfileDocRef(this.theUserId),updatePrivateProfile)
        }

        this.notice = {
          message: this.$t('profile.updated') as string,
          isShow: true,
          type: {'is-success': true}
        }
        this.observer.reset()

      }else{
        this.notice = {
          message: this.$t('profile.noChangedFields') as string,
          isShow: true,
          type: {'is-info': true}
        }
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateProfile = true
    }
  }

  async deleteUser(confirm: boolean){
    if(confirm){
      if(this.theUserId !== this.$store.getters.userId && (this.$store.getters.roles as Roles).includes('owner')){
          this.$store.commit("setLoading",true)
          this.$set(this.modalDeleteUser,'isLoading',true)
          try{
            await this.$updateDoc(this.$getUserPublicProfileDocRef(this.theUserId),{
              userId: this.theUserId,
              deleted: true
            } as UserPublicProfile)

            this.userPublicProfile = {} as UserPublicProfile
            this.userPrivateProfile = {} as UserPrivateProfile
            this.notice = {
              message: this.$t('editUser.deletedUser') as string,
              isShow: true,
              type: {'is-success': true}
            }
          }catch(error){
            const errorCode = this.$getErrorCode(error)
            const errorMessage = this.$t(this.$getErrorMessageKey(errorCode)) as string
            this.notice = {
              message: errorMessage,
              isShow: true,
              duration: 0,
              deleteButton: true,
              type: {'is-danger': true}
            }
          }finally{
            this.showModalDeleteUser = false
            this.$store.commit("setLoading",false);
            this.$set(this.modalDeleteUser,'isLoading',false)
          }
      }else{
        this.showModalDeleteUser = false
        this.notice = {
          message: this.$t('editUser.notAuthorized') as string,
          isShow: true,
          type: {'is-danger': true}
        }
      }
    }else{
      this.showModalDeleteUser = false
    }
  }

  async resetUid(confirm: boolean){
    if(confirm){
      if(this.theUserId !== this.$store.getters.userId && this.userPrivateProfile.uid !== ''){
          this.$store.commit("setLoading",true)
          this.$set(this.modalResetUid,'isLoading',true)
          try{
             const resetAuthUid = httpsCallable(functions,'resetAuthUid')

            const resetAuthUidRes = await resetAuthUid({
              userId: this.theUserId,
              schoolId: this.$store.getters.schoolId
            } as ResetAuthUidArg) as {data: ResetAuthUidRes}

            if(resetAuthUidRes.data){
              this.userPrivateProfile.uid = ''
              this.notice = {
                message: this.$t('editUser.resetAuthUid') as string,
                isShow: true,
                type: {'is-success': true}
              }
            }
          }catch(error){
            const errorCode = this.$getErrorCode(error)
            const errorMessage = this.$t(this.$getErrorMessageKey(errorCode)) as string
            this.notice = {
              message: errorMessage,
              isShow: true,
              duration: 0,
              deleteButton: true,
              type: {'is-danger': true}
            }
          }finally{
            this.modalResetUid.isShow = false
            this.$store.commit("setLoading",false);
            this.$set(this.modalResetUid,'isLoading',false)
          }
      }else{
        this.modalResetUid.isShow = false
        this.notice = {
          message: this.$t('editUser.notAuthorized') as string,
          isShow: true,
          type: {'is-danger': true}
        }
      }
    }else{
      this.modalResetUid.isShow = false
    }
  }
}

